<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="docTemplateId" prop="docTemplateId">
          <el-input v-model="dataForm.docTemplateId" placeholder="docTemplateId"></el-input>
      </el-form-item>
          <el-form-item label="共借人人数" prop="loanNo">
          <el-input v-model="dataForm.loanNo" placeholder="共借人人数"></el-input>
      </el-form-item>
      <el-form-item label="产品编号" prop="productCode">
          <el-select v-model="dataForm.productCode" placeholder="产品编号">
          <el-option 
             v-for="item in productCode"
             :key="item.value"
             :label="item.label"
             :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="文件类型编号" prop="contractTypeCode">
        <el-select v-model="dataForm.contractTypeCode" placeholder="文件编号">
          <el-option 
             v-for="item in file_type"
             :key="item.value"
             :label="item.label"
             :value="item.value"
          ></el-option>
        </el-select>
          <!-- <el-input v-model="dataForm.contractTypeCode" placeholder="文件类型代码(字典)"></el-input> -->
      </el-form-item>
          <!-- <el-form-item label="创建时间" prop="createTime">
          <el-input v-model="dataForm.createTime" placeholder="创建时间"></el-input>
      </el-form-item>
          <el-form-item label="创建人" prop="createBy">
          <el-input v-model="dataForm.createBy" placeholder="创建人"></el-input>
      </el-form-item>
          <el-form-item label="更新时间" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="更新时间"></el-input>
      </el-form-item>
          <el-form-item label="更新人" prop="updateBy">
          <el-input v-model="dataForm.updateBy" placeholder="更新人"></el-input>
      </el-form-item>
          <el-form-item label="版本号" prop="version">
          <el-input v-model="dataForm.version" placeholder="版本号"></el-input>
      </el-form-item> -->
          <el-form-item label="备注" prop="remark">
          <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  created(){
     // 文件类型
     this.$http.get(`/sys/dict/data/list?dataType=file_type`).then(r=>{
      console.log(r)
     this.file_type = r.data.data ? r.data.data.map(item => ({value:item.dictValue,label:item.dictLabel})) : []
    })
    this.$http.get('/sys/dict/data/list?dataType=contract_product').then(r =>{
      this.productCode = r.data.data ? r.data.data.map(
        item => ({value:item.dictValue,label:item.dictLabel})
      ) : []
    })
  },
  data () {
    return {
      file_type:[],
      productCode:[],

      visible: false,
      dataForm: {
        id: '',
        docTemplateId: '',
        loanNo: '',
        productCode: '',
        contractTypeCode: '',
        createTime: '',
        createBy: '',
        updateTime: '',
        updateBy: '',
        version: '',
        remark: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        docTemplateId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        loanNo: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        contractTypeCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        version: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/tcontractconfig/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/tcontractconfig/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>